export class ShareholderAccountModel {
  id: number = null;
  name: string = null;
  bank: string = null;
  branch: string = null;
  account: string = null;
  shareholderId: number = null;
  cetipAccount: number = null;
}
